export interface FaqItem {
  id: string;
  question: string;
  answer: string;
}

export interface FaqSection {
  id: string;
  title: string;
  items: FaqItem[];
}

export const FAQ_SECTIONS: FaqSection[] = [
  {
    id: 'start',
    title: 'С чего начать',
    items: [
      {
        id: 'what-is',
        question: 'Что это за бот?',
        answer:
          'Collector\'s Market — аукционы коллекционных товаров прямо в Telegram: фигурки, карточки, манга, комиксы и мерч. Бот открывает мини-приложение, а важные события (перебили ставку, победа, сделка) дублируются в чат с ботом.',
      },
      {
        id: 'how-open',
        question: 'Как открыть приложение?',
        answer:
          'Напиши боту /start и нажми «Открыть Collector\'s Market». Приложение работает только внутри Telegram.',
      },
      {
        id: 'navigation',
        question: 'Как устроена навигация?',
        answer:
          'Внизу пять вкладок: Лента — все активные лоты; Мои — твои аукционы и участия; Создать — выставить лот; Уведом. — активность; Профиль — статистика и отзывы.',
      },
    ],
  },
  {
    id: 'buyer',
    title: 'Покупателю',
    items: [
      {
        id: 'bidding',
        question: 'Как сделать ставку?',
        answer:
          'Открой лот, введи сумму в рублях (только целые числа) и нажми «Поставить» или «Поднять до». Первая ставка — не ниже стартовой цены, каждая следующая — минимум на шаг аукциона выше текущей. Быстрые кнопки «+шаг» помогают поднять цену одним нажатием. За один раз цену можно поднять не больше чем на 2 000 ₽ — это защита от накруток.',
      },
      {
        id: 'bid-limits',
        question: 'Какие ещё ограничения на ставки?',
        answer:
          'Чтобы не было накруток: одна ручная ставка не поднимает цену больше чем на 2 000 ₽; при создании лота минимальный шаг тоже не больше 2 000 ₽. Если у лота есть «Купить сразу», ставка и автоставка не могут быть выше этой суммы — иначе проще сразу выкупить лот. Без выкупа действует потолок 1 000× стартовой цены.',
      },
      {
        id: 'auto-bid',
        question: 'Как работает автоставка?',
        answer:
          'На странице лота нажми «Настроить автоставку» и укажи максимум. Система сама перебивает чужие ставки в пределах твоего лимита. Шаг можно оставить пустым — тогда используется минимальный шаг аукциона.',
      },
      {
        id: 'buy-now',
        question: 'Что такое «Купить сразу»?',
        answer:
          'Если продавец указал цену мгновенного выкупа, ты можешь закрыть аукцион одним нажатием по этой цене — без ожидания окончания таймера. Кнопка видна, пока текущая цена ниже цены выкупа.',
      },
      {
        id: 'anti-sniping',
        question: 'Продлевается ли аукцион в последние минуты?',
        answer:
          'Да. Если ставка (в том числе автоставка) приходит в последние 10 минут до конца, таймер сбрасывается ещё на 10 минут — так нельзя «снайпнуть» лот в последний момент. При выкупе по «Купить сразу» аукцион завершается сразу, без продления.',
      },
      {
        id: 'feed',
        question: 'Как искать лоты?',
        answer:
          'В ленте есть поиск по названию, фильтры по тегам и сортировка: скоро закончатся, новые, по цене, по числу ставок. Сбросить фильтры можно кнопкой в шапке.',
      },
    ],
  },
  {
    id: 'seller',
    title: 'Продавцу',
    items: [
      {
        id: 'create',
        question: 'Как выставить лот?',
        answer:
          'Вкладка «Создать» → пошаговая форма: фото, описание, цены, теги и предпросмотр. Укажи стартовую цену, минимальный шаг (от 1 до 2 000 ₽) и при желании цену «Купить сразу». Суммы вводятся целыми рублями. Лимит шага защищает от искусственного разгона цены.',
      },
      {
        id: 'moderation',
        question: 'Почему лот на модерации?',
        answer:
          'Новые и отредактированные лоты проверяет модератор перед публикацией. Статус виден во вкладке «Мои» → «На модерации». Если лот отклонили — на странице будет причина и кнопка «Редактировать и отправить заново».',
      },
      {
        id: 'edit',
        question: 'Можно ли изменить лот после публикации?',
        answer:
          'Редактирование доступно из раздела «Мои активные». После изменений лот снова может уйти на модерацию.',
      },
    ],
  },
  {
    id: 'deal',
    title: 'После аукциона',
    items: [
      {
        id: 'finished',
        question: 'Что происходит, когда аукцион закончился?',
        answer:
          'Победитель определяется по последней ставке (или по выкупу). Продавец и покупатель видят панель сделки на странице лота и получают уведомления. Дальше вы договариваетесь об оплате и передаче товара напрямую — сервис не принимает платежи.',
      },
      {
        id: 'confirm',
        question: 'Зачем подтверждать сделку?',
        answer:
          'Когда обе стороны нажмут «Подтвердить», сделка считается успешной. После этого можно оставить отзыв. Если контрагент не выходит на связь — воспользуйся «Проблема со сделкой»: жалоба уйдёт модератору.',
      },
      {
        id: 'reviews',
        question: 'Как работают отзывы?',
        answer:
          'После успешной сделки продавец и покупатель могут оценить друг друга по 5-балльной шкале и оставить комментарий. Рейтинг отображается в профиле и влияет на доверие к участнику.',
      },
    ],
  },
  {
    id: 'social',
    title: 'Подписки и профиль',
    items: [
      {
        id: 'subscribe',
        question: 'Зачем подписываться на продавцов?',
        answer:
          'На странице лота или в профиле продавца нажми «Подписаться». Список подписок находится в профиле. Так проще следить за новыми лотами любимых продавцов.',
      },
      {
        id: 'my-auctions',
        question: 'Что во вкладке «Мои»?',
        answer:
          'Пять разделов: активные лоты, где ты участвуешь, выигранные, на модерации и завершённые. Отсюда же можно перейти к редактированию или к лоту.',
      },
    ],
  },
  {
    id: 'notifications',
    title: 'Уведомления',
    items: [
      {
        id: 'in-app',
        question: 'Где смотреть уведомления в приложении?',
        answer:
          'Вкладка «Уведом.» — здесь история событий: перебили ставку, аукцион закончился, сделка, отзывы. Бейдж на иконке показывает непрочитанные; при открытии вкладки они помечаются прочитанными автоматически.',
      },
      {
        id: 'telegram',
        question: 'Приходят ли уведомления в Telegram?',
        answer:
          'Да, важные события бот дублирует в личные сообщения. Убедись, что чат с ботом не заглушён и бот не заблокирован.',
      },
    ],
  },
];
